export const pagesDevicesContractAndCostEn = {
  contract: {
    dataTable: {
      columns: {
        contract: 'contract',
        contractPeriod: 'contract date/contract period',
        evidence: 'evidence',
        item: 'item',
        leasePeriod: 'lease period',
        responsiblePerson: 'responsible person',
        status: 'status'
      }
    }
  },
  costOverview: {
    statCards: {
      fiscalYearAccumulatedCostActual: 'Accumulated actual cost for the fiscal year of the selected month',
      fiscalYearAccumulatedCostActualTooltip: 'The cumulative actual cost for the fiscal year that contains the selected month.',
      monthOverMonth: 'MoM',
      thisMonthActualCost: 'Actual cost for the selected month',
      thisMonthActualCostTooltip: 'The actual cost amount for the selected month.',
      thisMonthBudgetCost: 'Budgeted cost for the selected month',
      thisMonthBudgetCostTooltip: 'The budgeted cost amount for the selected month.',
      thisMonthVariance: 'Budget vs actual variance for the selected month',
      thisMonthVarianceTooltip: 'The difference between budget and actual for the selected month.',
      vsBudget: 'vs Budget',
      yearOverYear: 'YoY'
    },
    summaryChart: {
      helpTooltip: 'This chart shows the trend of planned costs, actual costs, and planned vs actual variance.',
      legend: {
        actual: 'Actual',
        planned: 'Planned',
        variance: 'Variance'
      },
      title: 'Cost Trend'
    },
    table: {
      contract: 'Contract',
      contractType: {
        LEASE: 'Lease Contract',
        PURCHASE: 'Purchase Contract'
      },
      department: 'Department',
      device: 'Device',
      fictitious: 'No entity',
      fraction: 'Rounding adjustment',
      item: 'Item',
      loadError: 'Failed to load cost data.',
      member: 'Member',
      memberCount: '{{count}} members',
      rowType: {
        actual: 'Actual',
        averageMonthlyLeaseCost: 'Average Monthly Lease Cost',
        averageUnitPrice: 'Average Unit Price',
        quantity: 'Quantity',
        scheduled: 'Planned',
        targetContract: 'Target Contract',
        variance: 'Variance'
      },
      total: 'Total',
      trend: 'Trend',
      unassigned: 'No user',
      unknown: 'Unknown department'
    }
  },
  paymentOverview: {
    statCards: {
      monthOverMonth: 'MoM',
      nextMonthPaymentPlanned: 'Planned payments for the month after the selected month',
      nextMonthPaymentPlannedTooltip: 'The planned payment amount for the month immediately following the selected month.',
      plannedVsActual: 'Planned vs Actual',
      thisMonthPaymentPlanned: 'Planned payments for the selected month',
      thisMonthPaymentPlannedTooltip: 'The planned payment amount for the selected month.',
      thisYearPaymentActual: 'Actual payments for the fiscal year of the selected month',
      thisYearPaymentActualTooltip: 'The total actual payment amount for the fiscal year that contains the selected month.',
      thisYearPaymentPlanned: 'Planned payments for the fiscal year of the selected month',
      thisYearPaymentPlannedTooltip: 'The total planned payment amount for the fiscal year that contains the selected month.',
      yearOverYear: 'YoY'
    },
    summaryChart: {
      helpTooltip: 'This chart shows the trend of planned payments, actual payments, and planned vs actual variance.',
      legend: {
        actual: 'Actual',
        planned: 'Planned',
        variance: 'Variance'
      },
      title: 'Payment Trend'
    },
    table: {
      contract: 'Contract',
      contractType: {
        LEASE: 'Lease Contract',
        PURCHASE: 'Purchase Contract'
      },
      department: 'Department',
      device: 'Device',
      fictitious: 'No entity',
      fraction: 'Rounding adjustment',
      item: 'Item',
      loadError: 'Failed to load payment data.',
      member: 'Member',
      memberCount: '{{count}} members',
      rowType: {
        actual: 'Actual',
        averageMonthlyLeaseCost: 'Average Monthly Lease Cost',
        averageUnitPrice: 'Average Unit Price',
        quantity: 'Quantity',
        scheduled: 'Scheduled',
        targetContract: 'Target Contract',
        variance: 'Variance'
      },
      total: 'Total',
      trend: 'Trend',
      unassigned: 'No user',
      unknown: 'Unknown department'
    }
  }
};